// BIZ UDPGothic は index.html の <link> (Google Fonts) で読み込む。オフラインのキオスク実機では
// 読込に失敗し、Windows 搭載の BIZ UDPゴシックが同じフォント名で使われる。
// アプリコード側では maplibre の localIdeographFontFamily 等でフォント名のみ必要。
export const bizUdpGothicFontFamily = '"BIZ UDPGothic", sans-serif';
